export default __webpack_public_path__ + "static/media/apply-full-transparent.b321dbb3.gif";